import { ArrowUpRight } from "../../../components/svgs";

const NucleusCtaSection = () => {
  return (
    <section className="bg-primary text-white py-16 md:py-20 px-4">
      <div className="container mx-auto flex flex-wrap items-center justify-between gap-10">
        <div className="max-w-2xl">
          <p className="text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-5">
            Your next step
          </p>
          <h2 className="text-white font-poppins font-bold tracking-[-0.03em] leading-tight text-3xl md:text-4xl lg:text-5xl mb-5">
            Bring practical technology learning closer to home.
          </h2>
          <span className="text-indigo-100 font-poppins text-base md:text-lg leading-relaxed block">
            Ask about The Nucleus for yourself, a community, school or local
            learning centre.
          </span>
        </div>

        <div className="grid gap-3 w-full sm:w-auto min-w-[230px]">
          <a
            href="mailto:nucleus@utiva.io"
            className="bg-secondary text-primary font-poppins font-extrabold rounded-xl flex items-center justify-between gap-4 px-5 py-4 custom-btn"
          >
            Ask about The Nucleus <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default NucleusCtaSection;
